import { useEffect, useRef, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import ExploreAndTrackJobsPaywall from 'builder/components/ExploreAndTrackJobsPaywall'
import { DashboardLayout } from 'builder/components/DashboardLayout'
import { SideMenu } from 'builder/features/navigation/components/SideMenu/SideMenu'
import { NavBar } from 'builder/features/navigation/components/NavBar'
import { NavBarMobile } from 'builder/features/navigation/components/NavBarMobile'
import { MobileMenu } from 'builder/features/navigation/components/MobileMenu/MobileMenu'
import { DashboardTabs } from 'builder/features/navigation/components/NavBar/DashboardTabs'

import { DashV4Tour } from 'builder/features/dashboard/components/DashV4Tour/DashV4Tour'
import { ResumeDistributionPromoModal } from 'builder/components/ResumeDistributionPromoModal'
import { ResumeDistributionGetStartedModal } from 'builder/components/ResumeDistributionGetStartedModal'
import { AutoApplyCreditsModal } from 'builder/components/AutoApplyCreditsModal/AutoApplyCreditsModal'
import { ResumeDistributionGotCreditsModal } from 'builder/components/ResumeDistributionGotCreditsModal'
import { AutoApplyResumeDistributionModal } from 'builder/features/modals/AutoApplyResumeDistributionModal'
import { ResumeDistributionNotEnoughCreditsModal } from 'builder/components/ResumeDistributionNotEnoughCreditsModal'
import { AppWelcomeModal } from 'builder/components/Panel/AppWelcomeModal'
import { AutoApplyUpsellModal } from 'builder/components/AutoApplyUpsellModal'
import { FullNameModal as FutureLearnFullNameModal } from 'builder/features/futureLearn/FullNameModal/FullNameModal'
import { Container, Content } from './styles'

export const NavigationView = ({ children }: { children?: React.ReactNode }) => {
  const { isPhone, isTablet } = useMediaQueries()
  const feat = useFeaturesConfig()
  const [isOpen, setIsOpen] = useState(true)
  const [isUserDropdownOpen, toggleUserDropdown] = useState(false)

  const location = useLocation()
  const prevLocation = useRef(location)

  const showTabs =
    !isPhone && !isTablet && feat.features.dashboardNavigationTabs && !feat.isDashboardV4()

  // Close all dropdowns and popups when user navigates to another route
  useEffect(() => {
    if (prevLocation.current === location) return
    prevLocation.current = location
    toggleUserDropdown(false)
  }, [location])

  if (
    !(
      feat.features.international ||
      feat.features.superApp ||
      (feat.features.dashboardV3 && !feat.features.dashboardV2)
    )
  ) {
    return <DashboardLayout />
  }

  return (
    <>
      <DashV4Tour />
      <AutoApplyUpsellModal />
      <AutoApplyCreditsModal />
      <ResumeDistributionPromoModal />
      <AutoApplyResumeDistributionModal />
      <ResumeDistributionGetStartedModal />
      <ResumeDistributionNotEnoughCreditsModal />
      <ExploreAndTrackJobsPaywall />
      <ResumeDistributionGotCreditsModal />
      <AppWelcomeModal />
      <FutureLearnFullNameModal />
      <NavBarMobile />
      {isPhone && <MobileMenu />}
      <Container>
        {!isPhone && <SideMenu isOpen={isOpen} setIsOpen={setIsOpen} />}
        <Content isOpen={isOpen}>
          <NavBar
            isUserDropdownOpen={isUserDropdownOpen}
            onUserDropdownToggle={toggleUserDropdown}
          />
          {showTabs && <DashboardTabs />}
          {children || <Outlet />}
        </Content>
      </Container>
    </>
  )
}
